/* src/app/modules/shared/components/column/column-strain/column-strain.component.scss */
/*# sourceMappingURL=column-strain.component.css.map */
